// extracted by mini-css-extract-plugin
module.exports = {"link":"views-GenericList__link--2K_2o","searchBox":"views-GenericList__searchBox--1KU72"};